<template>
  <div id="customerModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="customerModalLabel'" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <form v-if="isRender" class="modal-content" @submit.prevent="onSubmit">
        <div class="modal-header border-none">
          <h5 class="modal-title" id="customerModalLabel" style="display: inline-block">신규등록</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body border-none">
          <div class="form-group">
            <div class="col-xs-12">
              <label>사업년도 <small class="require-tag">*</small></label>
            </div>
            <div class="col-xs-12">
              <drop-down-list :class="['hz-dropdownlist-md']"
                              data-vv-name="business_year"
                              v-validate="{required: true}"
                              :options="businessYearList"
                              v-model="data['business_year']"></drop-down-list>
              <p v-if="errors.first('business_year')" class="is-invalid-text">{{ errors.first('business_year') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>고객명 <small class="require-tag">*</small></label>
            </div>
            <div class="col-xs-12">
              <input type="text"
                     class="hz-input-default hz-input-md"
                     data-vv-name="customer_name"
                     v-validate="{required: true}"
                     placeholder="홍길동"
                     v-model="data['name']">
              <p v-if="errors.first('customer_name')" class="is-invalid-text">{{ errors.first('customer_name') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>계약번호 <small class="require-tag">*</small></label>
            </div>
            <div class="col-xs-12">
              <input type="text"
                     class="hz-input-default hz-input-md"
                     data-vv-name="contract_no"
                     v-validate="{required: true}"
                     placeholder="HZEH-190001"
                     v-mask="'HZEH-######'"
                     v-model="data['contract_no']">
              <p v-if="errors.first('contract_no')" class="is-invalid-text">{{ errors.first('contract_no') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>연락처 <small class="require-tag">*</small></label>
            </div>
            <div class="col-xs-12">
              <input-phone :class="['hz-input-default', 'hz-input-md', {'is-invalid': errors.first('contact')}]"
                           data-vv-name="contact"
                           v-validate="{required: true}"
                           :placeholder="'010-0000-0000'"
                           v-model="data['contact']"></input-phone>
              <p v-if="errors.first('contact')" class="is-invalid-text">{{ errors.first('contact') }}</p>
            </div>
          </div>
          <div class="form-group" style="position: relative;">
            <div class="col-xs-12">
              <label>설치주소 <small class="require-tag">*</small></label>
            </div>
            <div class="col-xs-12">
              <input-address :class="'input-address-md col-xs-12 padding-0'"
                             data-vv-name="install_address"
                             v-validate="{required: true}"
                             :valueChange="true"
                             :placeholder="'설치주소를 입력하세요.'"
                             :defaultAddressType="'new'"
                             v-model="data['address']"></input-address>
            </div>
            <div class="col-xs-12" style="margin-top: 4px;">
              <input type="text"
                     class="hz-input-default hz-input-md"
                     placeholder="상세주소를 입력하세요."
                     v-model="data['rest_address']">
              <p v-if="errors.first('install_address')" class="is-invalid-text">{{ errors.first('install_address') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>계약일 <small class="require-tag">*</small></label>
            </div>
            <div class="col-xs-12">
              <date-picker data-vv-name="contract_date"
                           v-validate="{required: true}"
                           v-model="data['contract_date']"></date-picker>
              <p v-if="errors.first('contract_date')" class="is-invalid-text">{{ errors.first('contract_date') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <tooltip :title="`완료된 일정을 입력해주세요.`"></tooltip>
              <label>현장검토완료일</label>
            </div>
            <div class="col-xs-12">
              <date-picker :next="false" v-model="data['check_spot_date']"></date-picker>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>설치용량 <small class="require-tag">*</small></label>
            </div>
            <div class="col-xs-12">
              <drop-down-list :class="['hz-dropdownlist-md']"
                              data-vv-name="install_capacity"
                              v-validate="{required: true}"
                              :options="capacityList"
                              v-model="data['install_capacity']"></drop-down-list>
              <p v-if="errors.first('install_capacity')" class="is-invalid-text">{{ errors.first('install_capacity') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>주택유형</label>
            </div>
            <div class="col-xs-12">
              <drop-down-list :class="['hz-dropdownlist-md']"
                              :options="houseTypeList"
                              v-model="data['house_type']"></drop-down-list>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>시공사메모</label>
            </div>
            <div class="col-xs-12">
              <textarea class="hz-input-default"
                       style="width: 100%; padding: 8px;"
                       rows="10"
                       v-model="data['installer_memo']"></textarea>
            </div>
          </div>
          <div class="splitter margin-bottom-16">계약서류</div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>계약서사본 <small class="require-tag">*</small></label>
            </div>
            <div class="col-xs-12 input-md-wrap">
              <input-file :auth="true"
                          :autoUpload="true"
                          :options="fileUploadOption"
                          :saveUrl="dataUrl + saveUrl"
                          :removeUrl="dataUrl + removeUrl"
                          data-vv-name="copy_contract"
                          v-validate="{required: true}"
                          v-model="data['copy_contract_new']"></input-file>
              <p v-if="errors.first('copy_contract')" class="is-invalid-text">{{ errors.first('copy_contract') }}</p>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>건물등기부등본</label>
            </div>
            <div class="col-xs-12 input-md-wrap">
              <input-file :auth="true"
                          :autoUpload="true"
                          :options="fileUploadOption"
                          :saveUrl="dataUrl + saveUrl"
                          :removeUrl="dataUrl + removeUrl"
                          v-model="data['copy_of_register_new']"></input-file>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>신분증사본</label>
            </div>
            <div class="col-xs-12 input-md-wrap">
              <input-file :auth="true"
                          :autoUpload="true"
                          :options="fileUploadOption"
                          :saveUrl="dataUrl + saveUrl"
                          :removeUrl="dataUrl + removeUrl"
                          v-model="data['copy_idcard_new']"></input-file>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-12">
              <label>현장검토사진</label>
            </div>
            <div class="col-xs-12 input-md-wrap">
              <input-file :auth="true"
                          :autoUpload="true"
                          :options="fileUploadOption"
                          :saveUrl="dataUrl + saveUrl"
                          :removeUrl="dataUrl + removeUrl"
                          v-model="data['photo_check_spot_new']"></input-file>
            </div>
          </div>
        </div>
        <div class="modal-footer text-align-center border-none">
          <button type="submit" class="hz-btn-default hz-btn-md" style="width: 100px;"
                  data-dismiss="modal">취소</button>
          <button type="submit" class="hz-btn-primary hz-btn-md" style="width: 100px;">등록</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import InputPhone from 'common/components/InputPhone'
  import DropDownList from 'common/components/DropDownList'
  import InputAddress from 'common/components/InputAddress'
  import DatePicker from 'common/components/DatePicker'
  import Tooltip from 'common/components/Tooltip'
  import InputFile from 'common/components/InputFile'
  import api from '@/api/solarhome'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'customer-modal',
    components: {
      InputAddress,
      InputPhone,
      DropDownList,
      DatePicker,
      Tooltip,
      InputFile
    },
    props: {},
    data: function () {
      return {
        data: {},
        isRender: false,
        businessYearList: [],
        capacityList: [
          {name: '미정', value: 0},
          {name: '3kWp', value: 3},
          {name: '5kWp', value: 5},
          {name: '6kWp', value: 6}
        ],
        houseTypeList: [
          {name: '미정', value: '미정'},
          {name: '목조', value: '목조'},
          {name: '철골', value: '철골'},
          {name: '조립식', value: '조립식'},
          {name: '기타', value: '기타'}
        ],
        fileUploadOption: {
          validation: {
            allowedExtensions: ['.pdf', '.jpg', '.jpeg', '.png'],
            maxFileSize: 5 * 1024 * 1024,
            minFileSize: 0
          }
        },
        dataUrl: location.protocol + '//' + location.hostname.replace('biz', 'api'),
        saveUrl: '/biz/solarhome_file/?section=lease&category=customer',
        removeUrl: '/biz/solarhome_file/delete/'
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    watch: {},
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      init: function () {
        // 현재 년도
        const currentYear = new Date().getFullYear()

        // 사업년도 초기화
        this.businessYearList = [
          {name: currentYear, value: currentYear},
          {name: currentYear + 1, value: currentYear + 1}
        ]

        // 데이터 초기화
        this.data = {
          business_year: currentYear,
          name: '',
          contract_no: 'HZEH-' + currentYear.toString().substr(-2),
          contact: '',
          address: '',
          rest_address: '',
          contract_date: null,
          check_spot_date: null,
          check_spot_state: '',
          install_capacity: '',
          house_type: '',
          installer_memo: '',
          required_files: '',
          copy_contract_new: [],
          copy_of_register_new: [],
          copy_idcard_new: [],
          photo_check_spot_new: []
        }

        // validation 오류 목록을 초기화 한다.
        this.errors.clear()
      },
      show: function () {
        $('#customerModal').modal('show')
        // 파일 컴포넌트에 업로드 항목 초기화를 위해 입력폼을 다시 그리기 위한 플래그. (추후 보완이 필요 - 불필요한 렌더 반복)
        this.isRender = true
      },
      hide: function () {
        $('#customerModal').modal('hide')
      },
      onSubmit: function () {
        const vm = this

        // 모든 폼 필드에 대한 validation 실행
        vm.$validator.validateAll()

        vm.$nextTick(function () {
          if (vm.errors.any()) {
            // validation 후 조건을 충족 못한 필드가 있을 경우
            alert('필수 정보를 입력해주세요.')
          } else {
            // validation 통과 시 고객 신규등록 이벤트 트리거
            vm.addCustomer()
          }
        })
      },
      addCustomer: function () {
        const vm = this
        const data = $.extend(true, {}, vm.data)

        // 파일 목록
        const fileArr = ['copy_contract_new', 'copy_of_register_new', 'copy_idcard_new', 'photo_check_spot_new']

        // 업로드 된 파일 저장 시 ID 값만 저장한다.
        for (let i in fileArr) {
          const file = fileArr[i]
          // 업로드 된 파일 정보가 있을 때 ID 값만 저장
          if (data[file] && data[file].length > 0) {
            data[file] = data[file][0].id
          } else {
            data[file] = ''
          }
        }

        // 시공사에서 신규등록을 했기에 영업구분(시공사), 시공사ID(스토에어 저장된 user installer ID)를 default로 넘겨준다.
        data.sales_type = '시공사'
        data.installer = vm.user.lease_installer_id

        // 현장검토일이 입력되었을 경우, 현장검토상태를 완료로 넘겨준다.
        data.check_spot_state = data.check_spot_date !== null ? '완료' : ''

        // 신규고객등록
        api.saveCustomer(data, response => {
          if (response.error) {
            // 신규등록 실패 시. 메세지 출력
            vm.showToastMessage('신규등록 실패')
            console.log('add Customer fail!', response)
          } else {
            // 신규등록 성공 시, 페이지에 데이터를 초기화하는 이벤트 트리거
            vm.$emit('refresh')

            // 완료 메세지 출력 후 등록창을 닫는다
            vm.showToastMessage('신규등록 완료')
            vm.hide()
          }
        })
      }
    },
    created: function () {
      // 데이터 초기화
      this.init()
    },
    mounted: function () {
      const vm = this
      // 모달창 닫힐 때 초기화 이벤트 등록
      $('#customerModal').on('hidden.bs.modal', function () {
        vm.init()
        // 파일 컴포넌트에 업로드 항목 초기화를 위해 입력폼을 다시 그리기 위한 플래그. (추후 보완이 필요 - 불필요한 렌더 반복)
        vm.isRender = false
      })
    },
    beforeDestroy: function () {
      const vm = this
      // 페이지 이동 시 이벤트 해제
      $('#customerModal').off('shown.bs.modal', function () {
        vm.init()
        vm.isRender = false
      })
    }
  }
</script>

<style lang="scss" scoped>
  #customerModal {
    .modal-dialog  {
      min-width: 320px;
    }
    .form-group {
      margin: 0 0 16px 0;
      overflow: hidden;
      .col-xs-12 {
        position: initial;
        padding: 0;
        input {
          width: 100%;
        }
      }
      textarea {
        width: 100%;
        padding: 8px 16px;
      }
    }

    .modal-content {
      border-radius: 0;
    }

    .splitter {
      border: 1px solid $border-color;
      border-left-width: 0;
      border-right-width: 0;
      padding: 4px 16px;
      margin: 0 -15px;
      font-size: 12px;
      color: $second-color;
      background-color: $grey;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AddCustomerModal.vue